import type { RouteSeo } from '@/shared/seo/types';

export const storeSeo: RouteSeo = {
  title: 'BlueStone Showroom Near Me: Find BlueStone Jewellery Stores',
  description:
    'Find BlueStone jewellery stores near you. Walk into one of our showrooms and discover exquisite gold and diamond designs.',
  canonical: 'https://www.bluestone.com/store.html',
  robots: 'index, follow',
  meta: [
    { property: 'og:site_name', content: 'BlueStone' },
    { property: 'og:url', content: 'https://www.bluestone.com/store.html' },
    {
      property: 'og:title',
      content: 'BlueStone Showroom Near Me: Find BlueStone Jewellery Stores',
    },
    {
      property: 'og:description',
      content:
        'Find BlueStone jewellery stores near you. Walk into one of our showrooms and discover exquisite gold and diamond designs.',
    },
    { name: 'twitter:card', content: 'Summary' },
    { name: 'twitter:site', content: '@bluestone_com' },
    {
      name: 'twitter:title',
      content: 'BlueStone Showroom Near Me: Find BlueStone Jewellery Stores',
    },
    {
      property: 'twitter:description',
      content:
        'Find BlueStone jewellery stores near you. Walk into one of our showrooms and discover exquisite gold and diamond designs.',
    },
    { name: 'twitter:url', content: 'https://www.bluestone.com/store.html' },
  ],
};
